import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

const cache = new Map();

/* Short Wikipedia bio + MusicBrainz genres for an artist; renders nothing when nothing is known. */
export const ArtistBio = ({ name }) => {
  const [info, setInfo] = useState(cache.get(name) || null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let live = true;
    setOpen(false);
    if (cache.has(name)) { setInfo(cache.get(name)); return undefined; }
    setInfo(null);
    api.get("/artists/bio", { params: { name } }).then((r) => { cache.set(name, r.data); if (live) setInfo(r.data); }).catch(() => { cache.set(name, {}); if (live) setInfo({}); });
    return () => { live = false; };
  }, [name]);
  if (!info || (!info.bio && !info.genres?.length)) return null;
  const span = info.begin ? `${info.begin}–${info.end || "present"}` : "";
  const long = (info.bio || "").length > 260;
  return (
    <div className="mt-4 max-w-3xl" data-testid="artist-bio">
      {(info.genres?.length > 0 || span || info.country) && (
        <div className="mb-3 flex flex-wrap items-center gap-1.5" data-testid="artist-genres">
          {info.genres.map((g) => <span key={g} className="rounded-full border border-zinc-200 bg-white/70 px-2.5 py-0.5 text-[11px] capitalize text-zinc-700" data-testid={`artist-genre-${g.replace(/\s+/g, "-")}`}>{g}</span>)}
          {(span || info.country) && <span className="ml-1 font-mono text-[11px] text-zinc-500">{[info.country, span].filter(Boolean).join(" · ")}</span>}
        </div>
      )}
      {info.bio && (
        <p className={`text-sm leading-relaxed text-zinc-600 ${open ? "" : "line-clamp-3"}`} data-testid="artist-bio-text">{info.bio}</p>
      )}
      <div className="mt-1.5 flex items-center gap-3 text-xs">
        {long && <button onClick={() => setOpen((v) => !v)} className="font-medium text-zinc-900 hover:underline" data-testid="artist-bio-toggle">{open ? "Show less" : "Read more"}</button>}
        {info.url && <a href={info.url} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-zinc-500 hover:text-zinc-900" data-testid="artist-bio-source">Wikipedia <ExternalLink size={11} /></a>}
      </div>
    </div>
  );
};
